export default function(api: GlobalFetch) {
  return async function(id) {
    const response = await api.fetch(
      `/api/v2/booking/check/booking_property_id/${id}`,
      {
        method: 'GET',
      },
    )

    return await handleResponse(response)
  }
}

const handleResponse = async (response: Response) => {
  const { status } = response

  if (status === 200) {
    const data: IData = await response.json()
    return data.items
  }

  throw new Error('Error')
}

interface IData {
  items: {
    connected: number
    exists: number
  }
}
